export type NetworkErrorParams = {
	url: string;
	/** OpenAPI path template, e.g. `/invoices/{invoiceId}`. */
	schemaPath: string;
	method: string;
	online: boolean;
	aborted: boolean;
	cause?: unknown;
};

export class NetworkError extends Error {
	public readonly url: string;
	public readonly schemaPath: string;
	public readonly method: string;
	public readonly online: boolean;
	public readonly aborted: boolean;

	constructor({ url, schemaPath, method, online, aborted, cause }: NetworkErrorParams) {
		super(`Network request failed: ${method} ${url}`, { cause });
		this.name = 'NetworkError';
		this.url = url;
		this.schemaPath = schemaPath;
		this.method = method;
		this.online = online;
		this.aborted = aborted;
	}
}

export const toNetworkError = (request: Request, error: unknown, schemaPath: string): NetworkError => {
	const aborted = request.signal.aborted
		|| (error instanceof DOMException && error.name === 'AbortError');

	return new NetworkError({
		url: request.url,
		schemaPath,
		method: request.method,
		online: navigator.onLine,
		aborted,
		cause: error,
	});
};

export const isNetworkError = (error: unknown): error is NetworkError => error instanceof NetworkError;

export const isIgnorableNetworkError = (error: unknown): error is NetworkError =>
	isNetworkError(error) && (error.aborted || !error.online);
